import React from 'react';
import { compose, withProps } from 'recompose';
import styled, { StylesProps, cx } from '../../../lib/styles';
import holidayStyles from './Holiday_styles';
import { Holiday as HolidayModel } from '../../../models/holiday';
import { primaryType } from '../../../lib/holidayUtils';
import Image from '../Image';

const { isArray } = Array;

export interface HolidayProps {
  featureImage: string;
  featureText?: string;
  featured?: boolean;
  type: string;
  holiday: HolidayModel;
  onClick?: () => any;
}

const Holiday = ({
  featureImage,
  featureText,
  //@ts-ignore
  type,
  holiday: { title, 
    price_cents, 
    nights, 
    //@ts-ignore
    value_proposition, 
    link 
  },
  onClick,
  styles,
}: HolidayProps & StylesProps<typeof holidayStyles>) => (
  <a className={cx('Holiday', styles.link)} href={link} onClick={onClick}>
    <div id={`${title.stripSpecialCharacters().replaceSpaces('-').toLowerCase()}`} className={styles.featureImageContainer}>
      <Image
        lazy
        alt={title}
        className={cx(styles.image, 'Holiday__image')}
        src={featureImage}
        aspect={[16, 9]}
        resizeWidth={360}
        resizeFit={'crop'}
      />
      {featureText && <div className={styles.tag}>{featureText}</div>}
    </div>

    <div className={styles.text}>
      <h2 className={cx(styles.title, 'Holiday__title')}>{title}</h2>

      <div className={styles.priceContainer}>
        <span className={styles.subtitle}>
          {nights > 0
            ? `${nights} ${nights === 1 ? 'night' : 'nights'} from`
            : 'from'}
        </span>
        <span className={styles.price}>
          ${(price_cents / 100).toLocaleString()}
        </span>
        <span className={styles.subtitle}>pp</span>
      </div>
    </div>
  </a>
);

const tagText = {
  EXCLUSIVE: 'Exclusive',
  HOT: 'Save now',
};

export default compose(
  withProps(({ holiday: { types, feature_images, tags = [] } }) => ({
    type: primaryType(types) || 'STAY',
    featureText: isArray(tags)
      ? tags
          .map((tag: any) => tag.name)
          .reduce((result, tag) => result || tagText[tag], undefined)
      : undefined,
    featureImage:
      isArray(feature_images) && feature_images.length > 0
        ? feature_images[0].path
        : undefined,
  })),
  styled(holidayStyles)
)(Holiday);
